import { render } from "./TradeQuoteView.vue?vue&type=template&id=616e51d4&scoped=true"
import script from "./TradeQuoteView.vue?vue&type=script&lang=js"
export * from "./TradeQuoteView.vue?vue&type=script&lang=js"

import "./TradeQuoteView.vue?vue&type=style&index=0&id=616e51d4&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616e51d4"]])

export default __exports__